import React from "react";

const SvgLotSize = (props) => (
  <svg width={34} height={30} {...props}>
    <g stroke="#082746" fill="none" fillRule="evenodd">
      <path d="M.5.5h33v29H.5z" />
      <path
        d="M16.528 15L27.86 5M16.528 15l-10.39 9.09M18.7 5h9.161v7.76M6.139 16.135v7.956h9.182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgLotSize;
